
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';

import {Chart as ChartJS,TimeScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend} from "chart.js";
import { Chart } from "react-chartjs-2";
import 'chartjs-adapter-moment';
import { Bar, Doughnut, Line, Pie, Scatter } from 'react-chartjs-2';
  

import { Grid, Skeleton, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";
import moment from 'moment';


ChartJS.register(TimeScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend );

const ArcLineSingle = (props) => {
    // ChartJS.register(ArcElement, Tooltip, Legend);
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, XAxis, MaxValue, Label, Color, Proportion } = ComponentProperties
    const DataReportData = props.DataReportData

    const ValueArray = DataReportData.map(x => { return x[KeyToUse] })
    // KeyToUse will be an array
   
    const preprocess = ValueArray.filter(flt => flt)

    const converted = preprocess.map(dr => { return { x: moment(dr).format('YYYY-MM-DD') } })

    const minDate = _.minBy(converted, 'x')
    const ArcSumOfValues =
        _.chain(converted)
            .groupBy('x')
            .map((value, key) => ({ x: new Date(key), y: value.length }))
            .value()


    const data = {
        
        datasets: [{ data: _.sortBy(ArcSumOfValues, ['x']), borderColor: GetColor('PRIMARY',2), }]
    }
    // labels:ArcSumOfValues.map(r=> {return r.y}),
    // datasets: [{ data: ArcSumOfValues.map(r=> {return r.x}) }]     
    const options = {
        responsive: true,
        maintainAspectRatio: false,

        scales: {
            y: {
                // grid: {
                //     display: false,
                //     drawBorder:false
                // },
                ticks: {
                    display: true
                }
            },
            x: {
                type: "time",
                time: {
                    unit:"day"
                },
                // grid: {
                //     display: false,
                //     drawBorder:false
                // },
                ticks: {
                    display: true
                }
            }
        },
        plugins: {
            legend: {
                display: false,
                position: "bottom"
            },


        }

    }
    if (DataReportData && DataReportData.length > 0) {

        return (
            <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" align="center">{Label}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Line data={data} options={options}  />
                </Grid>
            </Grid>
        )
    }
    return (<Skeleton variant="rectangular" />)
}

export default ArcLineSingle